import { useMutation } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { App } from 'antd'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { Dimension } from '../types/Dimension'
import { createDimension } from '../service/dimensionService'
import { getDimensionOptions } from './getDimensionOptions'
import useCreateQueryItem from '../../../services/api/hooks/useCreateQueryItem'

export const useCreateDimension = () => {
  const companyId = useSelector(contextCompanyIdSelector)
  const options = getDimensionOptions(companyId)
  const { notification } = App.useApp()
  const createQueryItem = useCreateQueryItem()

  if (!companyId) {
    throw new Error('Company ID is required for dimensions.')
  }

  return useMutation({
    mutationKey: ['budget', 'dimension', 'create'],
    mutationFn: (data: Dimension) => createDimension(data, companyId),
    onSuccess() {
      createQueryItem([options])
    },
    onError(error) {
      notification.error({ message: error.message })
    }
  })
}
